export default "<p>divider-menu works!</p>\r\n";